module.exports = __webpack_public_path__ + "static/img/davis_pictgrid50_980x813.7a3bc7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid50_980x813.jpg
// module id = 2MA7
// module chunks = 0